import {useEffect, useState} from 'react';
import {QueryParamsEnum} from 'presentation/constants';
import {useQueryParams} from '../../hooks';

export function useFilters() {
	const {SEARCH_PARAMS, setSearchParams} = useQueryParams();
	const {orderBy, protocolType, status} = SEARCH_PARAMS;

	const [filterOrderByState, setFilterOrderByState] = useState(orderBy || '');
	const [filterProtocolTypeState, setFilterProtocolTypeState] = useState(protocolType || '');
	const [filterStatusState, setFilterStatusState] = useState(status || '');
	const [openDrawerState, setOpenDrawerState] = useState(false);
	const [isFilterChanged, setIsFilterChanged] = useState(false);

	useEffect(() => {
		const hasChanged =
			filterOrderByState !== (orderBy || '') ||
			filterProtocolTypeState !== (protocolType || '') ||
			filterStatusState !== (status || '');

		if (hasChanged) {
			setIsFilterChanged(true);
			const timer = setTimeout(() => {
				setIsFilterChanged(false);
			}, 400);

			return () => clearTimeout(timer);
		}

		return undefined;
	}, [
		filterOrderByState,
		filterProtocolTypeState,
		filterStatusState,
		orderBy,
		protocolType,
		status,
	]);

	const handleConfirmFilters = (handleCloseDrawer?: () => void) => {
		setSearchParams(
			prev => {
				prev.set(QueryParamsEnum.ORDER_BY, filterOrderByState);
				prev.set(QueryParamsEnum.PROTOCOL_TYPE, filterProtocolTypeState);
				prev.set(QueryParamsEnum.STATUS, filterStatusState);

				return prev;
			},
			{replace: true},
		);

		if (handleCloseDrawer) {
			handleCloseDrawer();
		}
	};

	const handleClearFilters = (handleCloseDrawer?: () => void) => {
		setFilterOrderByState('');
		setFilterProtocolTypeState('');
		setFilterStatusState('');

		setSearchParams(
			prev => {
				prev.delete(QueryParamsEnum.ORDER_BY);
				prev.delete(QueryParamsEnum.PROTOCOL_TYPE);
				prev.delete(QueryParamsEnum.STATUS);
				return prev;
			},
			{replace: true},
		);

		if (handleCloseDrawer) {
			handleCloseDrawer();
		}
	};

	const toggleDrawer = (isOpen: boolean) => {
		setOpenDrawerState(isOpen);
	};

	const getSelectedFiltersCount = () => [orderBy, protocolType, status].filter(Boolean).length;

	return {
		handleConfirmFilters,
		handleClearFilters,
		toggleDrawer,
		openDrawerState,
		setFilterOrderByState,
		setFilterProtocolTypeState,
		setFilterStatusState,
		filterOrderByState,
		filterProtocolTypeState,
		filterStatusState,
		getSelectedFiltersCount,
		isFilterChanged,
	};
}
